export default __webpack_public_path__ + "static/media/SupplementaryDetails.db900f57.svg";